import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { INFRASTRUCTURE } from "../../config/site";
import {
  Route,
  Zap,
  Recycle,
  Siren,
  Droplets,
  CloudRain,
  Video,
  Trees,
  Building2,
} from "lucide-react";

const ICONS = { Route, Zap, Recycle, Siren, Droplets, CloudRain, Video, Trees, Building2 };

export const Infrastructure = () => (
  <Section
    id="infrastructure"
    dark
    overline="Infrastructure"
    title="Industrial-grade, from day one"
    sub="Not promised infrastructure — completion-linked infrastructure. Your payments move only as the estate does."
  >
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {INFRASTRUCTURE.map((item, i) => {
        const Icon = ICONS[item.icon];
        return (
          <Reveal key={item.title} delay={(i % 3) * 0.08}>
            <div
              className="h-full border border-paper/15 bg-forest-light/40 p-6 transition-transform duration-200 hover:-translate-y-1"
              data-testid={`infra-${item.icon.toLowerCase()}`}
            >
              <Icon className="h-7 w-7 text-gold" strokeWidth={1.5} />
              <h3 className="mt-4 font-display text-xl font-medium text-paper">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-paper/65">{item.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </Section>
);
